export default __webpack_public_path__ + "static/media/optimismIcon.5de498fa.svg";